import Auth from '../auth';
import Users from '../users';
import RolePermissions from '../crud/rolePermissions';
import Coins from '../crud/coins';
import Currencies from '../crud/currencies';
import CurrencyExchangePairs from '../crud/currencyExchangePairs';
import Merchants from '../crud/merchants';
import Partners from '../crud/partners';
import PaymentGateways from '../crud/paymentGateways';
import Transactions from '../crud/transactions';
import Wallets from '../crud/wallets';
import ExternalTransactions from '../crud/externalTransactions';
import Files from '../crud/files';
import MerchantLocations from '../crud/merchantLocations';
import MerchantFiles from '../crud/merchantFiles';
import MerchantEmployees from '../crud/merchantEmployees';
import PartnerAccounts from '../crud/PartnerAccounts';
import MerchantLocationFiles from '../crud/merchantLocationFiles';
import FeeTransactions from '../crud/feeTransactions';
import PartnerApiKeys from '../crud/partnerApiKeys';
import PartnerHasCoins from '../crud/partnerHasCoins';
import CurrencyExchangeRates from '../crud/currencyExchangeRates';
import CoinCurrencyPairs from '../crud/coinCurrencyPairs';
import TwoFactorTotp from '../crud/twoFactorTotp';
import MerchantCategory from '../crud/merchantCategory';
import ActionPermissions from '../crud/actionPermissions';
import PayoutAccounts from '../crud/payoutAccounts';
import WalletCoupons from '../crud/walletCoupons';
import MerchantInvites from '../crud/merchantInvites';
import Roles from '../crud/roles';
import InviteCodes from '../crud/inviteCodes';
import CouponTransactions from '../crud/couponTransactions';
import MarketingCampaigns from '../crud/marketingCampaigns';
import MarketingAudiences from '../crud/marketingAudiences';
import SystemMessages from '../crud/systemMessages';


const ServerConfig = {
    auth: Auth,
    users: Users,
    rolePermissions: RolePermissions,
    actionPermissions: ActionPermissions,
    coins: Coins,
    currencies: Currencies,
    currencyExchangePairs: CurrencyExchangePairs,
    externalTransactions: ExternalTransactions,
    files: Files,
    merchants: Merchants,
    partners: Partners,
    paymentGateways: PaymentGateways,
    transactions: Transactions,
    wallets: Wallets,
    merchantLocationFiles: MerchantLocationFiles,
    feeTransactions: FeeTransactions,
    merchantLocations: MerchantLocations,
    merchantFiles: MerchantFiles,
    merchantEmployees: MerchantEmployees,
    merchantCategory: MerchantCategory,
    partnerAccounts: PartnerAccounts,
    partnerHasCoins: PartnerHasCoins,
    partnerApiKeys: PartnerApiKeys,
    coinCurrencyPairs: CoinCurrencyPairs,
    currencyExchangeRates: CurrencyExchangeRates,
    payoutAccounts: PayoutAccounts,
    walletCoupons: WalletCoupons,
    totp: TwoFactorTotp,
    merchantInvites: MerchantInvites,
    roles: Roles,
    inviteCodes: InviteCodes,
    couponTransactions: CouponTransactions,
    marketingAudiences: MarketingAudiences,
    marketingCampaigns: MarketingCampaigns,
    systemMessages: SystemMessages,

};

export class ServerBuilder {
    #serverData = {};

    constructor(serverData) {
        this.#serverData = serverData;
    }

    build() {
        const server = {};
        Object.entries(ServerConfig).forEach(([key, Server]) => {
            server[key] = new Server(this.#serverData);
        });
        return server;
    }
}
